try {
// newsletter modal (gate-modal template); posts to Shopify's customer form, success shows after the reload
(function(){
  var modal = document.getElementById('newsletterModal'); if (!modal) return;
  var form = document.getElementById('newsletterForm'), success = document.getElementById('nlSuccess');
  function open(done){
    form.classList.toggle('hidden', !!done); success.classList.toggle('shown', !!done);
    modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function close(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  [].forEach.call(document.querySelectorAll('.newsletter-trigger'), function(b){
    b.addEventListener('click', function(){
      var inline = document.getElementById('nlInline'); if (inline && inline.value) document.getElementById('nlEmail').value = inline.value;
      open(false);
    });
  });
  [].forEach.call(modal.querySelectorAll('[data-nl-close]'), function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  form.addEventListener('submit', function(){
    var area = document.getElementById('nlArea').value;
    form.querySelector('[name="contact[tags]"]').value = 'newsletter' + (area ? ', interest: ' + area.replace(/,/g, ' ') : '');
  });
  if (form.querySelector('[data-nl-posted]') || /[?&]customer_posted=true/.test(location.search)) open(true);
  else if (form.querySelector('[data-nl-error]')) open(false);
})();
} catch (e) { console.error("lys-v4 newsletter", e); }
